import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/60">
      <div className="max-w-[700px] mx-auto px-8 text-center">
        {String(t('certificate.cta.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
        <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
          {t('certificate.cta.title')}
        </h2>
        {String(t('certificate.cta.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-4 max-w-[550px] mx-auto">{__s}</p>))}
        {String(t('certificate.cta.onlineNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-400 tracking-[0.04em] leading-relaxed mb-10 max-w-[550px] mx-auto">{__s}</p>))}

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/courses"
            className="inline-block px-10 py-3.5 border border-foreground-400/30 text-foreground-700 text-[15px] tracking-[0.08em] hover:border-accent-500/50 hover:text-accent-600 transition-all duration-300 whitespace-nowrap w-full sm:w-auto text-center"
          >
            {t('certificate.cta.coursesBtn')}
          </Link>
          <Link
            to="/consultation"
            className="inline-block px-10 py-3.5 border border-foreground-400/30 text-foreground-700 text-[15px] tracking-[0.08em] hover:border-accent-500/50 hover:text-accent-600 transition-all duration-300 whitespace-nowrap w-full sm:w-auto text-center"
          >
            {t('certificate.cta.consultBtn')}
          </Link>
        </div>

        <Link
          to="/brochure"
          className="btn-glow inline-block px-10 py-3.5 bg-accent-500 hover:bg-accent-400 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
        >
          {t('certificate.cta.brochureBtn')}
        </Link>
      </div>
    </section>
  );
}
